// import { OrbitControls } from '@react-three/drei'
import Level from './Level.jsx'
import Lights from './Lights.js'
import {Physics, Debug} from '@react-three/rapier'
import GeometryContextProvider, { GeometryContext } from './store/store.js'
import Player from './Player/Player.jsx'
import { useContext } from 'react'
import {useSelector} from 'react-redux'
import Effects from './Effects/Effects.jsx'

export default function Experience()
{
    // const storeCtx = useContext(GeometryContext)
    const interfaceState = useSelector((state)=>state.interface)
    return <>
        <GeometryContextProvider>
            {/* <OrbitControls makeDefault /> */}
            <color args={['#252731']} attach='background'/>
            <Physics>
                {/* <Debug/> */}
                <Lights />
                <Level count={interfaceState.blocksCount} seed={interfaceState.blocksSeed}/>
                <Player/>
            </Physics>
            <Effects/>
        </GeometryContextProvider>

    </>
}